import { Stack, Switch, Typography } from '@mui/material'
import { useCallback, useContext } from 'react'

import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { AppContext } from '../../providers/AppProvider/AppProvider'
import {
  useCreateTimeClockMutation,
  useUpdateTimeClockMutation
} from '../../redux/api/timeClockApi'
import { TimeFromNowDynamicText } from './TimeFromNowDynamicText'

export const ClockInButton = () => {
  const { accessToken, shopId, userId } = useAccessTokenAndShopId()

  const [createTimeClock] = useCreateTimeClockMutation()

  const handleStartTimer = useCallback(() => {
    const now = new Date()
    createTimeClock({
      authorization: accessToken,
      timeClockInfo: {
        shop: shopId,
        employee: userId,
        clockInDateTime: now,
        createdAt: now,
        createdBy: userId
      }
    })
  }, [accessToken, createTimeClock, shopId, userId])
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="space-between"
      sx={{ width: '100%' }}>
      <Typography>Clocked Out</Typography>
      <Switch defaultChecked={false} onChange={handleStartTimer} />
    </Stack>
  )
}

export const ClockOutButton = () => {
  const { accessToken, userId } = useAccessTokenAndShopId()
  const { openTimeClockWithRelated } = useContext(AppContext)

  const [updateTimeClock] = useUpdateTimeClockMutation()

  const handleEndTimer = useCallback(() => {
    if (
      !openTimeClockWithRelated ||
      openTimeClockWithRelated.info!.clockOutDateTime
    ) {
      return
    }
    const now = new Date()
    updateTimeClock({
      authorization: accessToken,
      timeClockEntry: {
        ...openTimeClockWithRelated,
        info: {
          ...openTimeClockWithRelated.info,
          clockOutDateTime: now,
          modifiedAt: now,
          modifiedBy: userId
        }
      }
    })
  }, [accessToken, openTimeClockWithRelated, updateTimeClock, userId])
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="space-between"
      sx={{ width: '100%' }}>
      <Typography>
        <TimeFromNowDynamicText
          start={openTimeClockWithRelated!.info!.clockInDateTime!}
        />
      </Typography>
      <Switch defaultChecked={true} onChange={handleEndTimer} />
    </Stack>
  )
}
